import React, {Component} from 'react';
import ItemContainer from 'items/ItemContainer';
import {ItemDetail} from 'items/ItemDetail';

export default class EditItem extends Component {

    render() {
        return (
            <ItemContainer>
                <ItemDetail item={'t'}/>
            </ItemContainer>
        )
    }

}